/* Kala Futurism v1.2 — motion + interaction engine
   v1.2: removed custom cursor (native cursor restored) and page-transition sweep. */
(function () {
  'use strict';
  const doc = document;
  const html = doc.documentElement;
  const body = doc.body;
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesktop = window.matchMedia('(min-width: 901px) and (hover: hover)').matches;
  html.classList.add('kf-ready');
  body.classList.add('kala-fx');

  /* Scroll progress rail */
  (function progressRail() {
    const rail = doc.createElement('div');
    rail.className = 'kf-progress';
    body.appendChild(rail);
    let ticking = false;
    function update() {
      const scrollTop = window.scrollY;
      const docHeight = doc.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      rail.style.setProperty('--kf-scroll', pct + '%');
      if (scrollTop > 40) body.classList.add('kf-scrolled');
      else body.classList.remove('kf-scrolled');
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();

  /* Custom cursor removed in v1.2 — native cursor is used site-wide. */

  /* Reveal engine */
  (function reveal() {
    const items = doc.querySelectorAll('[data-fx]');
    if (!items.length) return;
    if (prefersReduced) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    items.forEach(function (el) { io.observe(el); });
    doc.querySelectorAll('[data-fx-stagger]').forEach(function (parent) {
      Array.from(parent.children).forEach(function (child, i) { child.style.setProperty('--i', i); });
    });
    // Fallback: force reveal after 5s in case IO fails
    setTimeout(function() {
      items.forEach(function (el) { if (!el.classList.contains('is-in')) el.classList.add('is-in'); });
    }, 5000);
  })();

  /* Split-text titles — split by WORD (not char) to avoid mid-word wraps */
  (function splitText() {
    if (prefersReduced) return;
    doc.querySelectorAll('[data-fx-split]').forEach(function (el) {
      if (el.dataset.kfSplit) return;
      el.dataset.kfSplit = '1';
      // Preserve inline HTML like <em>. Walk children and wrap only text nodes' words.
      function processNode(node) {
        const kids = Array.from(node.childNodes);
        kids.forEach(function (kid) {
          if (kid.nodeType === Node.TEXT_NODE) {
            const frag = doc.createDocumentFragment();
            // Split preserving whitespace tokens
            const parts = kid.textContent.split(/(\s+)/);
            parts.forEach(function (part) {
              if (part.match(/^\s+$/)) {
                frag.appendChild(doc.createTextNode(part));
              } else if (part.length > 0) {
                const wrap = doc.createElement('span');
                wrap.className = 'kf-split-word';
                wrap.style.display = 'inline-block';
                wrap.style.overflow = 'hidden';
                wrap.style.verticalAlign = 'baseline';
                const inner = doc.createElement('span');
                inner.className = 'kf-split-char';
                inner.textContent = part;
                wrap.appendChild(inner);
                frag.appendChild(wrap);
              }
            });
            node.replaceChild(frag, kid);
          } else if (kid.nodeType === Node.ELEMENT_NODE) {
            processNode(kid);
          }
        });
      }
      processNode(el);
      // Set indices
      el.querySelectorAll('.kf-split-char').forEach(function (span, i) {
        span.style.setProperty('--i', i);
      });
    });
  })();

  /* Magnetic buttons */
  if (isDesktop && !prefersReduced) {
    doc.querySelectorAll('[data-fx-magnet]').forEach(function (el) {
      const strength = parseFloat(el.dataset.fxMagnet) || 0.3;
      const inner = el.firstElementChild || el;
      let raf = null;
      el.addEventListener('mousemove', function (e) {
        const rect = el.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.transform = 'translate(' + (x * strength) + 'px,' + (y * strength) + 'px)';
          inner.style.transform = 'translate(' + (x * strength * 0.4) + 'px,' + (y * strength * 0.4) + 'px)';
        });
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; inner.style.transform = ''; });
    });
  }

  /* Parallax hero backgrounds */
  if (!prefersReduced) {
    const parallaxTargets = doc.querySelectorAll('[data-fx-parallax]');
    if (parallaxTargets.length) {
      function updateParallax() {
        parallaxTargets.forEach(function (el) {
          const speed = parseFloat(el.dataset.fxParallax) || 0.15;
          const rect = el.getBoundingClientRect();
          const centerOffset = rect.top + rect.height / 2 - window.innerHeight / 2;
          el.style.setProperty('--kf-parallax', (-centerOffset * speed) + 'px');
        });
      }
      window.addEventListener('scroll', updateParallax, { passive: true });
      updateParallax();
    }
  }

  /* Chapter rail */
  (function chapterRail() {
    const rail = doc.querySelector('[data-kf-rail]');
    if (!rail) return;
    const items = rail.querySelectorAll('.kf-rail__item');
    const targets = Array.from(items).map(function (it) {
      const sel = it.getAttribute('data-target');
      return sel ? doc.querySelector(sel) : null;
    });
    setTimeout(function () { rail.classList.add('is-on'); }, 800);
    items.forEach(function (item, i) {
      item.addEventListener('click', function () {
        if (targets[i]) targets[i].scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      });
    });
    function updateActive() {
      let activeIdx = 0;
      const midY = window.innerHeight * 0.4;
      targets.forEach(function (t, i) {
        if (!t) return;
        const r = t.getBoundingClientRect();
        if (r.top <= midY) activeIdx = i;
      });
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === activeIdx); });
      const active = targets[activeIdx];
      if (active && active.hasAttribute('data-kf-dark')) rail.dataset.theme = 'dark';
      else rail.removeAttribute('data-theme');
    }
    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  })();

  /* Numeric ticker */
  (function tickers() {
    if (prefersReduced) {
      doc.querySelectorAll('.kf-ticker').forEach(function (el) { el.textContent = el.dataset.value || el.textContent; });
      return;
    }
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        const el = e.target;
        io.unobserve(el);
        const target = parseFloat(el.dataset.value);
        if (isNaN(target)) return;
        const decimals = parseInt(el.dataset.decimals || '0', 10);
        const prefix = el.dataset.prefix || '';
        const suffix = el.dataset.suffix || '';
        const duration = parseInt(el.dataset.duration || '1400', 10);
        const start = performance.now();
        function step(now) {
          const t = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - t, 3);
          const val = target * eased;
          el.textContent = prefix + val.toFixed(decimals) + suffix;
          if (t < 1) requestAnimationFrame(step);
          else el.textContent = prefix + target.toFixed(decimals) + suffix;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    doc.querySelectorAll('.kf-ticker').forEach(function (el) { io.observe(el); });
  })();

  /* Page transition overlay removed in v1.2 — pages render immediately with no sweep. */

  /* Do NOT auto-elevate homepage — the Kala Futurism home section owns its own reveals. */
})();
